export default "ا\nب\nت\nث\nج\nح\nخ\nد\nذ\nر\nز\nس\nش\nص\nض\nط\nظ\nع\nغ\nف\nق\nك\nل\nم\nن\nه\nو\nي"